import z from 'zod/v4';
import { Brand } from '../branded-types';

export type SortLayoutAssignmentId = Brand<string, 'sortLayoutAssignmentId'>;

export interface ILayoutAssignment {
  layoutId: string;
  sortId: string;
  lastEditedAt: Date;
}

export const LAYOUT_ASSIGNMENT_SCHEMA: z.ZodType<ILayoutAssignment> = z.object({
  layoutId: z.string(),
  sortId: z.string(),
  lastEditedAt: z.coerce.date(),
});

export const LAYOUT_ASSIGNMENTS_SCHEMA: z.ZodType<ILayoutAssignment[]> =
  z.array(LAYOUT_ASSIGNMENT_SCHEMA);
